export interface PurchaseNotification {
  name: string
  province: string
  pack: 'Pack Base' | 'Megapack Premium'
  minutesAgo: number
}

export const purchaseNotifications: PurchaseNotification[] = [
  { name: 'María G.', province: 'Buenos Aires', pack: 'Megapack Premium', minutesAgo: 3 },
  { name: 'Jorge L.', province: 'Córdoba', pack: 'Pack Base', minutesAgo: 6 },
  { name: 'Silvia R.', province: 'Santa Fe', pack: 'Megapack Premium', minutesAgo: 8 },
  { name: 'Daniel M.', province: 'Mendoza', pack: 'Pack Base', minutesAgo: 11 },
  { name: 'Claudia P.', province: 'Tucumán', pack: 'Megapack Premium', minutesAgo: 14 },
  { name: 'Roberto A.', province: 'Salta', pack: 'Megapack Premium', minutesAgo: 17 },
  { name: 'Patricia V.', province: 'Entre Ríos', pack: 'Pack Base', minutesAgo: 21 },
  { name: 'Héctor S.', province: 'Chaco', pack: 'Megapack Premium', minutesAgo: 24 },
  { name: 'Gabriela T.', province: 'Misiones', pack: 'Pack Base', minutesAgo: 27 },
  { name: 'Miguel C.', province: 'Neuquén', pack: 'Megapack Premium', minutesAgo: 31 },
  { name: 'Lucía F.', province: 'San Juan', pack: 'Megapack Premium', minutesAgo: 35 },
  { name: 'Ana B.', province: 'Corrientes', pack: 'Pack Base', minutesAgo: 39 },
  { name: 'Osvaldo D.', province: 'Río Negro', pack: 'Megapack Premium', minutesAgo: 43 },
  { name: 'Norma E.', province: 'Santiago del Estero', pack: 'Pack Base', minutesAgo: 47 },
  { name: 'Fernando H.', province: 'Jujuy', pack: 'Megapack Premium', minutesAgo: 52 },
]
